import { useEffect } from 'react';

const useReveal = () => {
    useEffect(() => {
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const seen = new WeakSet();

        const observer = reducedMotion
            ? null
            : new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) return;
                    entry.target.classList.add('is-in');
                    observer.unobserve(entry.target);
                });
            }, { threshold: 0.12, rootMargin: '0px 0px -4% 0px' });

        const watch = (node) => {
            if (!(node instanceof Element) || !node.classList.contains('reveal') || seen.has(node)) return;
            seen.add(node);
            if (reducedMotion) {
                node.classList.add('is-in');
                return;
            }
            observer.observe(node);
        };

        document.querySelectorAll('.reveal').forEach(watch);

        const mutations = new MutationObserver((records) => {
            records.forEach((record) => {
                record.addedNodes.forEach((node) => {
                    watch(node);
                    if (node instanceof Element) node.querySelectorAll('.reveal').forEach(watch);
                });
            });
        });

        mutations.observe(document.body, { childList: true, subtree: true });

        return () => {
            observer?.disconnect();
            mutations.disconnect();
        };
    }, []);
};

export default useReveal;
